var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width full-height Main"},[_c('MuiNavbar',{staticClass:"Navbar",attrs:{"fixed":"","height":"70"}},[_c('template',{slot:"center"},[_vm._v("\n      User Company\n    ")])],2),_c('img',{attrs:{"src":_vm.state.assets.logo,"alt":"Ubeeqo"}}),_c('div',{style:({
      'padding-bottom': '70px',
    })}),_c('pre',[_vm._v(_vm._s(_vm.state))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }